import * as Turbo from '@hotwired/turbo'

import { clearAjaxModal } from './ajaxModal.js'

Turbo.session.drive = true

const visitHelper =
  (fn) =>
  (...args) => {
    const result = fn.apply(null, args)
    clearAjaxModal()
    return result
  }

export const clearNavigationCache = () => {
  Turbo.cache.clear()
}

export const redirectTo = visitHelper((url) =>
  Turbo.visit(url, { action: 'replace' }),
)

export const goToUrl = (url, options = {}) => {
  if (options?.dataTurbo === false) {
    clearAjaxModal()
    window.location.assign(url)
    return
  }
  return visitHelper(Turbo.visit)(url, options)
}